import React from "react";
import { useTranslation } from "react-i18next";
import { FaCubes, FaFlask, FaHeartbeat, FaProjectDiagram } from "react-icons/fa";

const CORE_TECH = {
  arch: ["Java", "Kotlin", "Spring Boot", "Quarkus", "Kafka", "REST/OpenAPI"],
  ai: ["Python", "TypeScript", "React/Next.js", "RAG", "Agent workflows", "OpenAI/Anthropic/Mistral"],
  stabilize: ["Java", "Kafka", "TCP/Netty", "Grafana", "ServiceNow", "Linux"],
  data: ["Python", "Kafka", "Spark/Flink", "PostgreSQL", "Elasticsearch", "Docker/Kubernetes"],
};

const ICONS = { arch: FaCubes, ai: FaFlask, stabilize: FaHeartbeat, data: FaProjectDiagram };
const ACCENTS = { arch: "accent-blue", ai: "accent-purple", stabilize: "accent-red", data: "accent-green" };

const OfferCard = ({ cardKey, Icon, accent }) => {
  const { t } = useTranslation();
  const bullets = t(`services.cards.${cardKey}.bullets`, { returnObjects: true });

  return (
    <div className={`offer-card ${accent}`}>
      <div className="offer-head">
        <div className="offer-title-row">
          {Icon && <Icon className="offer-title-icon" aria-hidden="true" />}
          <h3 className="offer-title">{t(`services.cards.${cardKey}.title`)}</h3>
        </div>
        <div className="offer-subtitle">{t(`services.cards.${cardKey}.subtitle`)}</div>
      </div>

      <ul className="offer-bullets">
        {Array.isArray(bullets) && bullets.map((b, i) => <li key={i}>{b}</li>)}
      </ul>

      <div className="offer-tech">
        <div className="offer-tech-title">Tech</div>
        <div className="offer-tech-list">{CORE_TECH[cardKey].join(" · ")}</div>
      </div>

      <div className="offer-cta">
        <a href="#contact" className="offer-btn">
          {t(`services.cards.${cardKey}.cta`)}
        </a>
      </div>
    </div>
  );
};

export default function EngagementOptions() {
  const { t } = useTranslation();

  return (
    <section id="services" className="engagement-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2>{t('services.heading')}</h2>
          <p className="text-muted mb-0">{t('services.description')}</p>
        </div>

        <div className="offer-grid">
          {['arch', 'ai', 'stabilize', 'data'].map((key) => (
            <OfferCard key={key} cardKey={key} Icon={ICONS[key]} accent={ACCENTS[key]} />
          ))}
        </div>

        <div className="text-center mt-0 d-flex flex-column align-items-center">
          <div className="cta-group" style={{ marginTop: "2rem" }}>
            <a href="#contact" className="btn-cta2 cta-blue">{t('services.ctaContact')}</a>
            <a href="#projects" className="btn-cta2 cta-green">{t('services.ctaProjects')}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
